import { FabNavItem } from '@fabric/components/common';

export const caiNavItem: FabNavItem[] = [
  {
    name: 'Mantenimiento',
    iconName: 'view_list',
    subItems: [
      {
        name: 'Cai',
        route: '/cai-maintenance',
        iconName: 'move_down'
      }
    ]
  }
];
